import React from "react";
import InputField from "../inputfields/InputField";
import SearchWithDropdown from "../Dropdowns/SearchWithDropdown";
import DropdownButtonForSearch from "../Dropdowns/DropdownButtonForSearch";

// Define the types for the props
interface InputFieldData {
  type: string;
  id: string;
  required?: boolean;
  tabIndex: number;
  disabled?: boolean;
  className?: string;
  options?: string[];
}

interface DynamicFieldProps {
  fieldData: InputFieldData;
  label: string;
  errors: { [key: string]: string };
  onInputChange: (id: string, value: string) => void;
  inputValues: { [key: string]: any };
  className?: string;
  handleDropdownSelect: (id: string, value: string) => void
  editLoading?: boolean;
}

const DynamicField: React.FC<DynamicFieldProps> = ({
  fieldData,
  label,
  errors,
  onInputChange,
  inputValues,
  handleDropdownSelect,
  editLoading
}) => {
  switch (fieldData.type) {
    case "input":
      return (
        <InputField
          inputItem={{
            labelName: label,
            id: fieldData.id,
          }}
          editLoading={editLoading}
          errorMessage={errors ? errors[fieldData.id] : ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onInputChange(fieldData.id, event.target.value)
          }
          value={inputValues[fieldData.id]}
          required={fieldData.required}
          tabIndex={fieldData.tabIndex}
          className={fieldData?.className}
          maindivstyle ='w-full'
          disabled={fieldData?.disabled}
        />
      );
    case 'dropdown':
      return (
        <DropdownButtonForSearch
          options={fieldData?.options || []}
          labelName={label}
          editLoading={editLoading}
          id={fieldData?.id}
          tabIndex={fieldData?.tabIndex}
          noSearch={true}
          className={fieldData?.className}
          onChange={handleDropdownSelect}
          selectedValue={inputValues[fieldData.id]}
          required={fieldData?.required}
          errorMessage={errors[fieldData?.id]}
          disabled={fieldData?.disabled}
          modalStyle={'w-full'}
        />
      )
    default:
      return null; // Gracefully handle unknown types
  }
};

export default DynamicField;
